import {
    DownloadDone,
    NotInterested,
    CurrencyExchange,
    Paid,
    PriceCheck,
    EventNote,
    Close,
    RequestQuote,
    Print,
    InstallDesktop,
    ClearAll,
    ModeEdit,
    Delete,
    Search,
    AddCircle,
    Functions,
    SwipeRight,
    PermIdentityOutlined,
    LockOutlined,
    BusinessCenter,
    MoneyOff,
    MoneyOffCsred,
    Cable,
    PriceChange,
    PaidTwoTone,
    Archive,
    Business,
    Check,
    AddCard,
    AccountCircle,
    AccountBox,
    EditRoad,
    MemoryOutlined,
    Dashboard,
    Flag,
    StickyNote2,
    GraphicEq,
    AccountTree,
    ReportGmailerrorred,
    Groups,
    Summarize,
    PhonelinkRing,
    PlaylistAddCheck,
    FilterList,
    Balance,
    People,
    Visibility,
    ToggleOff,
    ToggleOn,
    LocalAtm,
    Save,
} from '@mui/icons-material';
import { Icon, SvgIcon, SvgIconProps } from '@mui/material';

export interface IButtonProps extends SvgIconProps {
    icon: any;
    width?: number;
    height?: number;
    sx?: any;
}

export const icons = {
    DownloadDone: DownloadDone,
    NotInterested: NotInterested,
    CurrencyExchange: CurrencyExchange,
    Paid: Paid,
    PriceCheck: PriceCheck,
    EventNote: EventNote,
    Close: Close,
    RequestQuote: RequestQuote,
    Print: Print,
    InstallDesktop: InstallDesktop,
    ClearAll: ClearAll,
    ModeEdit: ModeEdit,
    Delete: Delete,
    Search: Search,
    AddCircle: AddCircle,
    Functions: Functions,
    SwipeRight: SwipeRight,
    PermIdentityOutlined: PermIdentityOutlined,
    LockOutlined: LockOutlined,
    BusinessCenter: BusinessCenter,
    MoneyOff: MoneyOff,
    MoneyOffCsred: MoneyOffCsred,
    Cable: Cable,
    PriceChange: PriceChange,
    PaidTwoTone: PaidTwoTone,
    Archive: Archive,
    Business: Business,
    Check: Check,
    AddCard: AddCard,
    AccountCircle: AccountCircle,
    AccountBox: AccountBox,
    EditRoad: EditRoad,
    MemoryOutlined: MemoryOutlined,
    Dashboard: Dashboard,
    Flag: Flag,
    StickyNote2: StickyNote2,
    GraphicEq: GraphicEq,
    AccountTree: AccountTree,
    ReportGmailerrorred: ReportGmailerrorred,
    Groups: Groups,
    Summarize: Summarize,
    PhonelinkRing: PhonelinkRing,
    PlaylistAddCheck: PlaylistAddCheck,
    FilterList: FilterList,
    Balance: Balance,
    People: People,
    Visibility: Visibility,
    ToggleOff: ToggleOff,
    ToggleOn: ToggleOn,
    LocalAtm: LocalAtm,
    Save: Save,
};

export const IconComponent = (properties: IButtonProps) => {
    return (
        <SvgIcon
            {...properties}
            component={properties.icon}
            disabled
            sx={properties.sx}
            // sx={{ width: 24, height: 24 }}
        />
    );
};
